import { useEffect, useState } from 'react';

/**
 * useMediaQuery — reactive boolean for a CSS media query (e.g.
 * `useMediaQuery('(max-width: 640px)')`). Mirrors the factory-init +
 * stable-subscription + legacy-fallback pattern of `usePortraitOrientation`
 * and `useCoarsePointer` so SSR / private mode / Safari < 14 all behave.
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    try { return window.matchMedia(query).matches; }
    catch (_e) { return false; }
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    let mq;
    try { mq = window.matchMedia(query); }
    catch (_e) { return undefined; }

    const onChange = (e) => setMatches(!!e.matches);
    setMatches(mq.matches);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, [query]);

  return matches;
}
